import { render, staticRenderFns } from "./menuMobile.vue?vue&type=template&id=2a77ea4a&scoped=true"
import script from "./menuMobile.vue?vue&type=script&lang=js"
export * from "./menuMobile.vue?vue&type=script&lang=js"
import style0 from "./menuMobile.vue?vue&type=style&index=0&id=2a77ea4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a77ea4a",
  null
  
)

export default component.exports